// The custom field definitions a project template carries (its requiredFields /
// optionalFields), and the values a project stores against them.
//
// Backend shapes (openwrench-app app/models/workorder/Project.scala):
//   FieldType(key, type)                            — the definition
//   FieldTypeDetails(key, valueAsString, valueType) — the project's value
//
// `multipleChoice` extends FieldType with `multipleChoices` and
// `allowMultipleAnswerSelections`, named exactly as the troubleshooting step model
// names them (models/workorder/TroubleshootingStep.scala) so the two features read
// the same way. Those two keys are pending on the backend — see
// docs/project-template-fields/backend-delta.md.

export const PROJECT_TEMPLATE_FIELD_TYPES = {
	string: 'string',
	number: 'number',
	currency: 'currency',
	date: 'date',
	multipleChoice: 'multipleChoice',
};

export const PROJECT_TEMPLATE_FIELD_TYPE_OPTIONS = [
	{ value: PROJECT_TEMPLATE_FIELD_TYPES.string, label: 'Text' },
	{ value: PROJECT_TEMPLATE_FIELD_TYPES.number, label: 'Number' },
	{ value: PROJECT_TEMPLATE_FIELD_TYPES.currency, label: 'Currency' },
	{ value: PROJECT_TEMPLATE_FIELD_TYPES.date, label: 'Date' },
	{ value: PROJECT_TEMPLATE_FIELD_TYPES.multipleChoice, label: 'Multiple Choice' },
];

// A multiple-choice field is useless with one option, and the picker would render as
// a dropdown of one — same floor troubleshooting enforces.
export const MIN_MULTIPLE_CHOICE_OPTIONS = 2;

// The two field groups on a template, in the order they are authored and displayed.
export const PROJECT_TEMPLATE_FIELD_GROUPS = ['requiredFields', 'optionalFields'];
